// extracted by mini-css-extract-plugin
export default {"location":"Locations_location__Z0EZc","description":"Locations_description__IL4Dj","filter":"Locations_filter__x4rs6"};